import React from 'react'
import './contacts.css';
import Contactform from '../../contactusform/Contactform';
function Contact() {
    return (
        <div className='home_contactus_section'>
            <div className='contectus_container'>
                <div className='backgroung_pic'>
                    {/* <img src={pic} alt='profile-picture' /> */}

                   
                        <div className='info_container'>
                            <div className='heading_section'>
                                <h5>With over 15 years of experience in the industry</h5>
                            <h3>Best Engineering & Construction Company In India</h3>
                            </div>

                            <div className='content_section'>
                                <div className='content_section_one'>
                                <h5>Address</h5>
                                <h4>Our Office</h4>
                                <p>Khalpol , Thakurpukur, Kolkata - 700063</p>
                                <div className='phone_number'><p>Phone: +91 033-4005-2352</p></div>
                                <div className='email'>Email: info@bestengineering.</div>
                                </div>
                                <div className='Contact_section'>
                                    <Contactform/>
                                 </div>
                            </div>
                            
                        </div>
                   
                </div>
            </div>

        </div>
    )
}

export default Contact
